export default __webpack_public_path__ + "static/hp-brand-deck-28-e79ae85e483c6a8e572ad77da2db5ed4.png";